import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/kiss': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M168 176C150.3 176 136 190.3 136 208S150.3 240 168 240 200 225.7 200 208 185.7 176 168 176zM304 308C304 288.8 275.2 266.5 232.5 264 228.7 263.6 225.1 266.4 224.3 270.2 223.4 274 225.4 277.9 229 279.4L245.9 286.6C258.9 292.1 266.7 300.1 266.7 308.1S258.9 324.1 246 329.6L229 336.8C223.3 339.2 223 349 229 351.6L245.9 358.8C258.9 364.3 266.7 372.3 266.7 380.3S258.9 396.3 246 401.8L229 409C225.4 410.5 223.4 414.4 224.3 418.2 225.1 421.8 228.4 424.4 232.1 424.4H232.6C275.4 421.9 304.1 399.6 304.1 380.4 304.1 367.4 290.7 353.1 268.9 344.4 290.6 335.3 304 321 304 308zM248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM248 456C137.7 456 48 366.3 48 256S137.7 56 248 56 448 145.7 448 256 358.3 456 248 456zM328 176C310.3 176 296 190.3 296 208S310.3 240 328 240 360 225.7 360 208 345.7 176 328 176z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/kiss.js
// module id = z2WJ
// module chunks = 144